import configs from '@configs'
import { format, SHA256 } from 'crypto-js'
import dayjs from 'dayjs'
import { Bills } from 'gadjet-v2-types/dist/model'
import qs from 'qs'
import { useEffect, useMemo, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

const isDev = process.env.NODE_ENV === 'development'

export default function DesktopPay(): JSX.Element {
  const { push } = useHistory()
  const { state } = useLocation<{ bill?: Bills; mid: string; merchantKey: string }>()
  const { bill, mid, merchantKey } = state || {}

  const form = useRef<HTMLFormElement>(null)

  const isDeposit = useMemo(() => bill?.type === 'deposit', [bill])
  const payMethod = useMemo(() => (isDeposit ? 'BANK,VBANK' : 'CARD,BANK,VBANK'), [isDeposit])

  const actionUrl = useMemo(() => {
    if (!bill) return ''
    const resultUrl = `${window.location.protocol}//${window.location.host}/bills/${bill.billId}/pay/result`
    const apiHost = isDev ? configs.API_HOST_DEV : configs.API_HOST
    return `${apiHost}/interlock/nicepay?resultUrl=${resultUrl}`
  }, [bill])

  const item = useMemo(() => {
    if (!bill) return ''
    const { spaces, additions, surcharges } = bill
    const items = [...spaces, ...additions, ...surcharges]
    const names = items.map(({ name }) => name)

    if (names.length === 0) return '상품없음'
    if (names.length === 1) return names[0]
    if (names.length > 1) return `${names[0]} 외 ${names.length - 1}건`
  }, [bill])
  const price = useMemo(() => Number(bill?.price || 0), [bill])

  const pay = () => {
    if (!bill) return
    if (!form?.current) return

    const date = dayjs().format('YYYYMMDDHHmmss')
    const moid = Date.now()
    const signData = SHA256(`${date}${mid}${price}${merchantKey}`, { format: format.Hex }).toString()

    const formData = {
      Moid: moid,
      GoodsName: item,
      Amt: price,
      MID: mid,
      EdiDate: date,
      SignData: signData,
      ReqReserved: qs.stringify({ type: 'bill-payment', billId: bill.billId, branchId: bill.branchId }),
      PayMethod: payMethod,
      CharSet: 'utf-8',
    }

    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement('input')
      input.setAttribute('name', key)
      input.setAttribute('value', String(value))
      input.setAttribute('type', 'hidden')
      form.current?.appendChild(input)
    })

    const _w = window as any
    _w.nicepaySubmit = () => {
      form.current?.submit()
    }
    _w.nicepayClose = () => {
      alert('결제취소')
    }
    _w.goPay(form.current)
  }

  const importScript = () =>
    new Promise((resolve) => {
      const scriptTag = document.createElement('script')

      scriptTag.src = 'https://web.nicepay.co.kr/v3/webstd/js/nicepay-3.0.js'
      scriptTag.text = 'text/script'
      scriptTag.async = true
      scriptTag.onload = () => resolve(true)

      const body = document.querySelector('body')
      body?.appendChild(scriptTag)
    })

  const importScriptAndPay = async () => {
    await importScript()
    pay()
  }

  useEffect(() => {
    const isDeny = !bill || !mid || !merchantKey
    if (isDeny) return push('/error')
    importScriptAndPay()
  }, [bill, mid, merchantKey])

  return <form ref={form} method="post" action={actionUrl} acceptCharset="EUC-KR" />
}
